import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import { Flex, Icon, Link, Button } from 'nallian-shared-ui/lib/components';
import { Text } from 'nallian-shared-ui/lib/layout/styles';
import { ORGANISATION_STATES } from '../../../app/constants';

const InviteComplete = ({ invitationFetch }) => {
  const { t } = useTranslation();

  useEffect(() => {
    // if the organisation state is already active, we should redirect to the portal directly since we have already seen the 'proceed' button on the STS.
    // In case the organisation state was still pending, the user has completed organisation details & legal docs. Should see an extra confirmation step.
    const organisationState = get(invitationFetch.value, 'organisation.activeStateId');
    if (organisationState === ORGANISATION_STATES.ACTIVE) {
      history.push(`/overview`);
    }
  }, [invitationFetch.value]);

  return (
    <Flex direction="column" alignItems="center">
      <Icon name="check circle" color="green" size="huge" />
      <Text>
        <br />
        {t('welcomeToThePlatform')}
        <br />
        <br />
        {t('welcomeToThePlatformInfo')}
        <br />
      </Text>
      <Link to="/overview">
        <Button content={t('proceed')} />
      </Link>
    </Flex>
  );
};

InviteComplete.propTypes = { invitationFetch: PropTypes.object.isRequired };

export default InviteComplete;
